export const MODULE_REGISTRATION = '/module_registration/' as const
export const MODULE_REGISTRATION_ALL = `${MODULE_REGISTRATION}all` as const
export const MODULE_REGISTRATION_BATCH = `${MODULE_REGISTRATION}batch` as const
export const MODULE_REGISTRATION_REGISTER = `${MODULE_REGISTRATION}register` as const
